import { getIdentity } from '@sdc/auth';
import { useEffect, useState } from 'react';
import { compareAnnouncements, isVisibleAnnouncement } from '../../shared/validation';

export interface Announcement {
  id: string;
  title: string;
  body_md: string;
  valid_until: string | null;
  pinned: boolean;
  created_at: string;
}

/**
 * Ankündigungen für Homescreen-Panel, Strip und Overlay.
 *
 * Absichtlich ein Hook an einer Stelle: vorher lud der Strip die Liste selbst,
 * mit dem News-Panel wäre daraus ein zweiter identischer Request geworden.
 * RLS liefert nur die eigene Org und nur gültige Einträge.
 */
export function useAnnouncements(): { items: Announcement[] | null; error: string | null } {
  const [items, setItems] = useState<Announcement[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;

    void (async () => {
      const { data, error: queryError } = await getIdentity()
        .from('announcements')
        .select('id, title, body_md, valid_until, pinned, created_at');

      if (!active) return;
      if (queryError) {
        setError(queryError.message);
        setItems([]);
        return;
      }
      const rows = (data ?? []) as Announcement[];
      setItems(rows.filter((row) => isVisibleAnnouncement(row)).sort(compareAnnouncements));
    })();

    return () => {
      active = false;
    };
  }, []);

  return { items, error };
}
